import styles from './Top.module.scss'
import Button from '../../components/Button/Button'
import React from 'react'
import Breadcrumb from 'components/commons/Breadcrumb/Breadcrumb'

interface Props {
  contents: {
    smallTitle: string
    title: string[]
    text: string
    imgLink: string
  }
  paths: { name: string; url: string }[]
}

const Top: React.FC<Props> = ({ contents, paths }) => {
  const titleBr = contents.title.map((text, index) => (
    <React.Fragment key={index}>
      {text}
      {index < contents.title.length - 1 && <br />}
    </React.Fragment>
  ))
  return (
    <div className={styles.top}>
      <div className={styles.top_wrapper}>
        <div className={styles.top_contents}>
          <Breadcrumb paths={paths} />
          <div className={styles.title_wrapper}>
            <div className={styles.color_text}>{contents.smallTitle}</div>
            <h1 className={styles.catch_copy}>{titleBr}</h1>
            <div className={styles.shoulder_copy}>{contents.text}</div>
          </div>
          <div className={styles.button_wrapper}>{/* <Button /> */}</div>
        </div>
        <img src={contents.imgLink} alt="" className={styles.top_image} />
      </div>
    </div>
  )
}
export default Top
